import axiosInstance from './axiosInstance';
import { 
  IUrineLevelDistributionPayload, 
  IUrineLevelDistributionItem,
  IUrineLevelDistributionByTimeItem
} from '../interfaces/Analysis/IAnalysis';

class AnalysisService {
  private static instance: AnalysisService;
  private constructor() {}

  public static getInstance(): AnalysisService {
    if (!AnalysisService.instance) {
      AnalysisService.instance = new AnalysisService();
    }
    return AnalysisService.instance;
  }

  public async getUrineLevelDistribution(
    params: IUrineLevelDistributionPayload
  ): Promise<IUrineLevelDistributionItem[]> {
    try {
      const response = await axiosInstance.get<IUrineLevelDistributionItem[]>(
        '/analyse/urine_level_distribution',
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch urine level distribution data');
    }
  }
  
  public async getUrineLevelDistributionByTime(
    params: IUrineLevelDistributionPayload
  ): Promise<IUrineLevelDistributionByTimeItem[]> {
    try {
      const response = await axiosInstance.get<IUrineLevelDistributionByTimeItem[]>(
        '/analyse/urine_level_distribution_by_time_range',
        { params }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch urine level distribution by time data');
    }
  }
}

export default AnalysisService.getInstance(); 